import axios from "axios";
import React, { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useLocation } from "react-router-dom";
import CoordinatorView from "./CoordinatorView";
import { Tooltip } from "@mui/material";
import Modal from "../common/CommonModal";
import CreditCustomerList from "../common/CreditCustomerList";

const CoordinatorCreation = () => {
  const initialCoordinatorFormData = {
    coordinatorID: "",
    name: "",
    defaultDepartment: "",
    account: "",
    monthlyTarget: 0,
    email: "",
    mobileNo: "",
  };
  const [formData, setFormData] = useState({ initialCoordinatorFormData });
  const [departmentList, setDepartmentList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [reloadList, setReloadList] = useState(false);
  const [crPCModalOpen, setCrPCModalOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedAccountDesc, setSelectedAccountDesc] = useState("");
  const [selectedAccountBal, setSelectedAccountBal] = useState("");
  const [accounts, setAccounts] = useState([]);

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    type: "success",
  });
  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const fetchDepartments = async () => {
    try {
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;

      const apiURL = `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/DEPTLIST/-/-`;
      const response = await axios.get(apiURL);
      const data = response.data;
      // console.log("Dept List:", data);
      setDepartmentList(data);
    } catch (error) {
      console.error("Error while fetching Dept list!", error);
    }
  };

  const fetchLocations = async () => {
    try {

       let department = localStorage.getItem("currentSelectedDepartment") || "-";
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;
      const apiURL = `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/LOCATONLIST_ALL/${department}/-`;
      const response = await axios.get(apiURL);
      const data = response.data;
      // console.log("Location List:", data);
      setLocationList(data);
    } catch (error) {
      console.error("Error while fetching location list!", error);
    }
  };

  useEffect(() => {
    fetchDepartments();
    fetchLocations();
  }, []);

  const location = useLocation();
  useEffect(() => {
    const editSpCode = location.state?.code;
    console.log("Edit Coordinator in COD Creation:",editSpCode)
    if (isEdit) {
      fetchEditCoordinatorSingle(editSpCode);
    }
  }, [location.state]);

  const fetchEditCoordinatorSingle = async (editSpCode) => {
    if (!editSpCode) return;

    try {
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;
      const url = `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/CORDMASTERLIST/${editSpCode}/-`;

      const response = await axios.get(url);

      console.log("Result of Coordinator Single Fetch:", response.data);

      if (response.data && response.data.length > 0) {
        const sp = response.data[0];

        // Map API → form fields
        setFormData({
          coordinatorID: sp.code || "",
          name: sp.Salesperson_Name || "",
          defaultDepartment: sp.deptno || "",
          account: sp.Account || "",
          monthlyTarget: sp.Target || 0,
          email: sp.email || "",
          mobileNo: sp.MobileNo || "",
        });
      } else {
        console.log("No Coordinator found for:", editSpCode);
      }
    } catch (error) {
      console.error("Error fetching Coordinator data:", error);
      // setError("Failed to load Coordinator, please try again.");
    }
  };

  useEffect(() => {
    console.log("formData:", formData);
  }, [formData]);

  const saveCoordinator = async () => {
    try {
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;

      const payload = [
        {
          CmpCode: company_code_from_local_storage,
          mode: isEdit ? "EDIT" : "ENTRY",
          scode: formData.coordinatorID || "",
          sname: formData.name || "",
          target: formData.monthlyTarget || 0,
          deptno: formData.defaultDepartment || "",
          location: formData.account || "",
          email: formData.email || "",
          mobileno: formData.mobileNo || "",
        },
      ];

      const apiURL = `${apiBaseURL}/api/CRMCoordinatorReg`;
      const response = await axios.post(apiURL, payload);

      console.log("API Response:", response.data);

      setSnack({
        open: true,
        message: "Coordinator saved successfully!",
        type: "success",
      });

      setReloadList((prev) => !prev);

      setIsEdit(false);
      setFormData(initialCoordinatorFormData);
    } catch (error) {
      console.error("Error saving Coordinator:", error);

      setSnack({
        open: true,
        message: "Failed to save Coordinator!",
        type: "error",
      });
    }
  };

  const isFormEmpty =
    !formData.coordinatorID || !formData.name || !formData.mobileNo;

  const fetchAccountList = async (valueToAPI) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";

    let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMAccountList/${companyCode}/ACCOUNTLIST/${department}/${valueToAPI}/-/-`;

    try {
      const response = await axios.get(apiUrl);
      setAccounts(response.data || []);
    } catch (err) {
      console.error("Error while fetching voucher accounts", err);
    }
  };

  const handleCustomerSelect = (data) => {
    setSelectedAccount(data.ACCOUNT);
    setSelectedAccountDesc(data.DESCRIPTION);
    setSelectedAccountBal(data.BALANCE);
    // console.log("data:", data);
    setFormData((prev) => ({
      ...prev,
      account: data.ACCOUNT,
    }));
    setCrPCModalOpen(false);
  };

  return (
    <div className="mx-4">
      <h2 className="text-xl text-gray-800">Coordinator Creation Dashboard</h2>

      <div className="grid grid-cols-4 gap-4 space-y-2">
        {/* Coordinator ID */}
        <div className="mt-2 ">
          <label className="block text-xs text-gray-600 my-2">
            Coordinator ID
          </label>
          {isEdit ? (
            <input
              value={formData.coordinatorID || ""}
              readOnly
              // onChange={(e) => handleChange("coordinatorID", e.target.value)}
              className="cursor-not-allowed placeholder-gray-400 w-full px-3 py-2 text-sm rounded border bg-gray-200 border-gray-200"
              placeholder="Coordinator ID"
            />
          ) : (
            <input
              value={formData.coordinatorID || ""}
              onChange={(e) => handleChange("coordinatorID", e.target.value)}
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded border bg-gray-100 border-gray-200"
              placeholder="Coordinator ID"
            />
          )}
        </div>

        {/* Name */}
        <div>
          <label className="block text-xs text-gray-600 my-2">Name</label>
          <input
            value={formData.name || ""}
            onChange={(e) => handleChange("name", e.target.value)}
            className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded border bg-gray-100 border-gray-200"
            placeholder="Name"
          />
        </div>

        {/* Monthly Target */}
        <div>
          <label className="block text-xs text-gray-600 my-2">
            Monthly Target
          </label>
          <input
            type="number"
            value={formData.monthlyTarget || ""}
            onChange={(e) => handleChange("monthlyTarget", e.target.value)}
            className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded border bg-gray-100 border-gray-200"
            placeholder="Monthly Target"
          />
        </div>

        {/* Default Department (Dropdown) */}
        <div>
          <label className="block text-xs text-gray-600 my-2">
            Default Department
          </label>
          <select
            value={formData.defaultDepartment || ""}
            onChange={(e) => handleChange("defaultDepartment", e.target.value)}
            className="w-full px-3 py-2 text-sm rounded border bg-gray-100 border-gray-200"
          >
            <option value="">Select Department</option>

            {departmentList.map((item, index) => (
              <option key={index} value={item.deptno}>
                {item.deptnodesc}
              </option>
            ))}
          </select>
        </div>

        {/* Account */}
        <Tooltip title={formData.account > 0 ? "" : "Press F2"} arrow>
          <div className="relative ">
            <label className="block text-xs text-gray-600 my-2">Account</label>
            <input
              onKeyDown={(e) => {
                if (e.key === "F2") {
                  fetchAccountList("CASH");
                  // setSelectedRowIndex(index);
                  setCrPCModalOpen(true);
                  // setDropdownOpenIndex(null);
                }
              }}
              value={formData.account || ""}
              // onChange={(e) => handleChange("account", e.target.value)}
              className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded border bg-gray-100 border-gray-200"
              placeholder="Account"
            />
            {formData.account && (
              <button
                onClick={() =>
                  setFormData((prev) => ({
                    ...prev,
                    account: "",
                  }))
                }
                className="absolute right-1 top-[46px] text-white hover:text-gray-300 bg-gray-500 px-1 rounded text-sm"
              >
                Clear
              </button>
            )}
          </div>
        </Tooltip>

        {/* Email */}
        <div>
          <label className="block text-xs text-gray-600 my-2">Email</label>
          <input
            type="email"
            value={formData.email || ""}
            onChange={(e) => handleChange("email", e.target.value)}
            className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded border bg-gray-100 border-gray-200"
            placeholder="Email"
          />
        </div>

        {/* Mobile No */}
        <div>
          <label className="block text-xs text-gray-600 my-2">Mobile No</label>
          <input
            type="tel"
            value={formData.mobileNo || ""}
            onChange={(e) => handleChange("mobileNo", e.target.value)}
            className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded border bg-gray-100 border-gray-200"
            placeholder="Mobile No"
          />
        </div>

        {/* Default Location (Dropdown) */}
        {/* <div>
          <label className="block text-xs text-gray-600 my-2">
            Default Location
          </label>
          <select
            value={formData.defaultLocation || ""}
            onChange={(e) => handleChange("defaultLocation", e.target.value)}
            className="w-full px-3 py-2 text-sm rounded border bg-gray-100 border-gray-200"
          >
            <option value="">Select Location</option>

            {locationList.map((item, index) => (
              <option key={index} value={item.loc_code}>
                {item.DESC}
              </option>
            ))}
          </select>
        </div> */}
      </div>
      <div className="flex items-center justify-center mt-8">
        <button
          onClick={saveCoordinator}
          disabled={isFormEmpty}
          className={`p-3 rounded shadow transition text-white
      ${
        isFormEmpty
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-green-500 hover:bg-green-600"
      }`}
        >
          {isEdit ? "Update Coordinator" : "Save Coordinator"}
        </button>
      </div>

      <CoordinatorView
        setIsEdit={setIsEdit}
        isEdit={isEdit}
        reload={reloadList}
        setreload={setReloadList}
      />

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.type}
          variant="filled"
          elevation={6}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>
      {crPCModalOpen && (
        <Modal
          isOpen={crPCModalOpen}
          onClose={() => setCrPCModalOpen(false)}
          title={"Ledger List"}
          size="xxl"
          header={true}
        >
          <CreditCustomerList
            defaultType="Cash"
            handleCustomerSelect={handleCustomerSelect}
          />
          {/* <ProductListing/> */}
        </Modal>
        // <PettyCashAccountPopup setCrPCModalOpen={setCrPCModalOpen} />
      )}
    </div>
  );
};

export default CoordinatorCreation;
